module.exports = __webpack_public_path__ + "static/media/foward.10e174da.svg";